import { ref } from 'vue'

import { defineStore } from 'pinia'

export default defineStore('mapTools', () => {
  const measure = ref(false)
  const swipe = ref(false)
  return { measure, swipe }
})
